import React from 'react';
import { Zap, Waves, Moon } from 'lucide-react';
import { FadeIn } from './FadeIn';
const voltages = [{
  name: 'High-Voltage',
  state: 'Bouncing off the walls',
  need: 'Needing to burn energy',
  icon: Zap,
  color: 'bg-orange-50 text-orange-600 border-orange-200',
  iconBg: 'bg-orange-100'
}, {
  name: 'Medium-Flow',
  state: 'Ready to focus',
  need: 'Needing engaged play',
  icon: Waves,
  color: 'bg-teal-50 text-teal-700 border-teal-200',
  iconBg: 'bg-teal-100'
}, {
  name: 'Low-Voltage',
  state: 'Crashing and whining',
  need: 'Needing to decompress',
  icon: Moon,
  color: 'bg-indigo-50 text-indigo-600 border-indigo-200',
  iconBg: 'bg-indigo-100'
}];
export function EnergyFilter() {
  return <section className="bg-white py-24 sm:py-32 overflow-hidden" data-id="element-15">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-16">
        <div className="mx-auto max-w-3xl text-center mb-16" data-id="element-17">
          <FadeIn data-id="element-18">
            <span className="text-amber font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-19">
              The Unique Mechanism
            </span>
            <h2 className="font-serif text-3xl font-bold tracking-tight text-navy sm:text-4xl mb-6" data-id="element-20">
              The Energy-Level Activity Filter
            </h2>
            <p className="text-lg text-muted" data-id="element-21">
              Instead of searching for a random toy, this system teaches you to
              diagnose your child's "Voltage" in ten seconds.
            </p>
          </FadeIn>
        </div>

        <div className="mx-auto max-w-5xl" data-id="element-22">
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-3 mb-16" data-id="element-23">
            {voltages.map((voltage, index) => <FadeIn key={voltage.name} delay={index * 0.15} direction="up" data-id="element-24">
                <div className={`rounded-2xl border p-8 h-full flex flex-col items-center text-center ${voltage.color}`} data-id="element-25">
                  <div className={`p-4 rounded-full mb-6 ${voltage.iconBg}`} data-id="element-26">
                    <voltage.icon className="h-8 w-8" data-id="element-27" />
                  </div>
                  <h3 className="text-2xl font-bold mb-2" data-id="element-28">{voltage.name}</h3>
                  <p className="font-medium opacity-90 mb-1" data-id="element-29">
                    "{voltage.state}"
                  </p>
                  <p className="text-sm opacity-75" data-id="element-30">{voltage.need}</p>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn delay={0.4} data-id="element-31">
            <div className="bg-navy rounded-2xl p-8 sm:p-10 text-center shadow-xl" data-id="element-32">
              <p className="text-xl sm:text-2xl font-serif text-white leading-relaxed" data-id="element-33">
                "When the activity matches the energy,{' '}
                <span className="text-amber" data-id="element-34">
                  independent play happens automatically.
                </span>
                "
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}